import React from 'react';
import { 
    Container, 
    Card, 
    CardContent, 
    Typography, 
    Alert, 
    Button, 
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from '@mui/material';
import { 
    Warning as WarningIcon, 
    ExitToApp as LogoutIcon,
    CheckCircle as CheckIcon
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

const PermissionDenied = () => {
    const { logout } = useAuth();

    const handleLogout = () => {
        logout();
    };

    return (
        <Container maxWidth="md" sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            minHeight: '100vh',
            py: 4
        }}>
            <Card sx={{ width: '100%', maxWidth: 600 }}>
                <CardContent sx={{ textAlign: 'center', p: 5 }}>
                    <Box sx={{ mb: 4 }}>
                        <WarningIcon sx={{ fontSize: 80, color: 'warning.main' }} />
                    </Box>
                    
                    <Typography variant="h4" component="h1" color="error" gutterBottom>
                        Access Denied
                    </Typography>
                    
                    <Alert severity="warning" sx={{ mb: 4, textAlign: 'left' }}>
                        <Typography variant="h6" gutterBottom>
                            No Permission to Access Application
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 3 }}>
                            You don't have permission to access the Franchise Management System. 
                            Your account needs to be granted appropriate roles by a store owner or administrator.
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2, fontWeight: 'bold' }}>
                            What you can do:
                        </Typography>
                        <List dense>
                            <ListItem sx={{ py: 0 }}>
                                <ListItemIcon sx={{ minWidth: 36 }}>
                                    <CheckIcon fontSize="small" color="primary" />
                                </ListItemIcon>
                                <ListItemText 
                                    primary="Contact your store owner to request access" 
                                    primaryTypographyProps={{ variant: 'body2' }}
                                />
                            </ListItem>
                            <ListItem sx={{ py: 0 }}>
                                <ListItemIcon sx={{ minWidth: 36 }}>
                                    <CheckIcon fontSize="small" color="primary" />
                                </ListItemIcon>
                                <ListItemText 
                                    primary="Ask an administrator to assign you the appropriate role" 
                                    primaryTypographyProps={{ variant: 'body2' }}
                                />
                            </ListItem>
                            <ListItem sx={{ py: 0 }}>
                                <ListItemIcon sx={{ minWidth: 36 }}>
                                    <CheckIcon fontSize="small" color="primary" />
                                </ListItemIcon>
                                <ListItemText 
                                    primary="Verify that your email address is correctly associated with your account" 
                                    primaryTypographyProps={{ variant: 'body2' }}
                                />
                            </ListItem>
                        </List>
                    </Alert>

                    <Box sx={{ 
                        display: 'flex', 
                        gap: 2, 
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        mb: 4
                    }}>
                        <Button 
                            variant="outlined" 
                            startIcon={<LogoutIcon />}
                            onClick={handleLogout}
                            size="large"
                        >
                            Logout
                        </Button>
                    </Box>

                    <Typography variant="caption" color="text.secondary">
                        If you believe this is an error, please contact technical support.
                    </Typography>
                </CardContent>
            </Card>
        </Container>
    );
};

export default PermissionDenied;
